import CustomSegment from '../../../../components/CustomSegment';
import PageTitle from '../../../../components/PageTitle';
import { useSegment } from '../../../../hooks/useSegment';
import DashboardLayout from '../../../../layouts/DashboardLayout';
import type { SegmentedType } from '../../../../types/global.types';
import Filters from './_components/Filters';
import BonusAddition from './BonusAddition';
import PaySheet from './PaySheet';
import LeaveEncashment from './LeaveEncashment';
import PayrollGenerate from './PayrollGenerate';
import SalaryGrade from './SalaryGrade';

export type PayrollSegmentType =
  | 'salary-sheet-generate'
  | 'salary-grade-management'
  | 'daily-pay'
  | 'leave-encashment'
  | 'bonus-addition';

const EmpPayroll = () => {
  const { segment, setSegment } = useSegment<PayrollSegmentType>(
    'emp-payroll-segment',
    'salary-sheet-generate',
    false,
  );

  const SEGMENT_CONFIG: SegmentedType<PayrollSegmentType>[] = [
    {
      value: 'salary-sheet-generate',
      label: 'Payroll & Salary Sheet Generate',
      view: <PayrollGenerate />,
    },
    {
      value: 'salary-grade-management',
      label: 'Salary Structure & Grade Management',
      view: <SalaryGrade />,
    },
    {
      value: 'daily-pay',
      label: 'Pay Sheet',
      view: <PaySheet />,
    },
    {
      value: 'leave-encashment',
      label: 'Leave Encashment',
      view: <LeaveEncashment />,
    },
    {
      value: 'bonus-addition',
      label: 'Bonus / Addition',
      view: <BonusAddition />,
    },
  ];
  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);

  return (
    <DashboardLayout title="Payroll">
      <PageTitle
        classNames={{ root: 'items-start' }}
        title="Payroll"
        items={[
          { title: 'Dashboard', path: '/admin/employee/dashboard' },
          { title: currentSegment?.label },
        ]}
      >
        <Filters type={segment} />
      </PageTitle>

      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.view}</div>
    </DashboardLayout>
  );
};

export default EmpPayroll;
